<template>
  <div>
    <el-table
      style="width: 100%;"
      border
      size="mini"
      :header-cell-style="{background: '#ecf4ff',color: '#333',fontWeight: '900',fontSize: '0.28rem',}"
      :data="LinkOrders"
    >
      <el-table-column label="订单编号" width="200">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.order_num" placement="top">
            <el-link type="primary"
              @click="handleOrderInfo(scope.row.id)">{{ scope.row.order_num }}
          </el-link>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="订单状态" width="80">
        <template slot-scope="scope">
          {{ scope.row.order_status }}
        </template>
      </el-table-column>
      <el-table-column label="订单类型">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.order_reg && scope.row.order_reg.order_reg_name === '单品'"
            :content="scope.row.meal_singles.length > 0 ? getMeals(scope.row.meal_singles) : ''"
            placement="top">
            <span class="count-style" v-if="scope.row.order_reg">
              {{ scope.row.order_reg.order_reg_name }}:{{ getMeals(scope.row.meal_singles) }}
            </span>
          </el-tooltip>
          <template v-else>
            <span class="count-style">
              {{ scope.row.order_reg ? scope.row.order_reg.order_reg_name : "" }}
            </span>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="订单金额" width="80">
        <template slot-scope="scope">
          {{ scope.row.total_amount }}
        </template>
      </el-table-column>
      <el-table-column label="是否会员" width="80">
        <template slot-scope="scope">
          {{ scope.row.is_member === true ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label="是否线索" width="80">
        <template slot-scope="scope">
          {{ scope.row.is_clue=== true ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label="归属地" width="80">
        <template slot-scope="scope">
          <span
            v-if="scope.row.phone_customer_isp">{{ scope.row.phone_customer_isp.province }}&nbsp;&nbsp;{{ scope.row.phone_customer_isp.city }}
          </span>
        </template>
      </el-table-column>
    </el-table>
    <el-drawer title="订单信息" :visible.sync="orderInfoVisible" direction="rtl" size="50%"
      :before-close="handleOrderInfoClose" :append-to-body="true" :modal-append-to-body="false">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem;">
        <order-info :orderId="orderInfoId"></order-info>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import OrderInfo from 'common/OrderInfo'
export default {
  name: 'LinkOrder',
  props: {
    currentTel: String
  },
  components: {
    OrderInfo
  },
  data () {
    return {
      LinkOrders: [],
      orderInfoVisible: false,
      orderInfoId: null
    }
  },
  watch: {
    currentTel: function (val) {
      if (val) {
        this.getLinkedOrder()
      }
    }
  },
  methods: {
    getLinkedOrder () {
      this.$axios
        .post('api/admin/tyc_order/get_link_order', {tel: this.currentTel})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.LinkOrders = data.data.linkOrder
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    getMeals(meals) {
      let str = ''
      for (let i = 0; i < meals.length; i++) {
        str += meals[i].item_name + '，'
      }
      return str
    },
    handleOrderInfo(orderId) {
      this.orderInfoVisible = true
      setTimeout(() => {
        this.orderInfoId = orderId
      })
    },
    handleOrderInfoClose(done) {
      this.orderInfoId = null
      done()
    }
  },
  mounted () {

  }
}
</script>

<style lang="stylus" scoped>
.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/common/LinkOrder.vue